import type { DevSettings } from '../devSettings.types';

export const getDevSettingsFromUrl = ({
  search,
}: {
  search: string;
}): DevSettings | null => {
  const params = new URLSearchParams(search);
  const environmentId = params.get('environmentId') ?? undefined;
  const apiBaseUrlOrigin = params.get('apiBaseUrlOrigin') ?? undefined;
  const apiBaseUrlPath = params.get('apiBaseUrlPath') ?? undefined;
  const extensionsParam = params.get('extensions') ?? undefined;

  let extensions: DevSettings['extensions'] | undefined;

  if (extensionsParam) {
    try {
      extensions = JSON.parse(extensionsParam) as DevSettings['extensions'];
    } catch {
      return null;
    }
  }

  if (!apiBaseUrlOrigin || !apiBaseUrlPath || !environmentId || !extensions) {
    return null;
  }

  return {
    apiBaseUrlOrigin,
    apiBaseUrlPath,
    environmentId,
    extensions,
  };
};
